import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Checkbox } from '../ui/checkbox';
import { hdr } from '../../pages/PlanningRessourcesPage';

const API = process.env.REACT_APP_BACKEND_URL;

const appel = async (url, method, body) => {
  const r = await fetch(`${API}/api/planning-ressources${url}`, { method, headers: hdr(), body: JSON.stringify(body) });
  return r.ok ? r.json() : null;
};

export const ChantierDialog = ({ chantier: c, onClose, onMaj }) => {
  const [go, setGo] = useState(c.date_debut || '');
  const [h, setH] = useState({ personne: '', date: new Date().toLocaleDateString('sv-SE'), heures: '' });
  const [prix, setPrix] = useState('');
  const [enCours, setEnCours] = useState(false);
  const maj = async (body) => { const r = await appel(`/chantiers/${c.id}`, 'PUT', body); if (r) onMaj(r); };
  const cocher = (i) => maj({ taches_prep: c.taches_prep.map((t, j) => (j === i ? { ...t, fait: !t.fait } : t)) });
  const ajouterHeures = async () => { const r = await appel(`/chantiers/${c.id}/heures`, 'POST', { ...h, heures: Number(h.heures) }); if (r) { onMaj(r); setH({ personne: '', date: '', heures: '' }); } };
  const terminer = async () => {
    if (enCours || !window.confirm('Terminer ce chantier ? La traçabilité et la facture en brouillon seront créées.')) return;
    setEnCours(true);
    const r = await appel(`/chantiers/${c.id}/terminer`, 'POST', { stocks_utilises: [], prix_heure_ht: prix ? Number(prix) : null });
    if (r) onMaj({ ...c, statut: 'termine', facture_brouillon_id: r.facture_brouillon_id });
    setEnCours(false);
  };
  const totalH = (c.heures || []).reduce((s, x) => s + Number(x.heures || 0), 0);

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent data-testid="chantier-dialog" className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader><DialogTitle>{c.titre}</DialogTitle></DialogHeader>
        <div className="space-y-4 text-sm">
          <p className="text-stone-600">{c.client_nom} · {c.lieu} · {c.nb_jours} j · <span className="font-medium">{c.statut}</span></p>
          {c.condition_meteo && <p className="bg-amber-50 border border-amber-200 rounded-lg p-2">Condition : {c.condition_meteo}{c.alternative && <><br />Sinon : {c.alternative}</>}</p>}
          <div className="flex items-end gap-2">
            <div><label className="text-xs text-stone-500">Date de démarrage</label><Input data-testid="chantier-date-go" type="date" value={go} onChange={(e) => setGo(e.target.value)} /></div>
            <Button data-testid="chantier-go-btn" className="rounded-full bg-emerald-700 hover:bg-emerald-800" disabled={!go} onClick={() => maj({ date_debut: go, statut: 'planifie' })}>Donner le go</Button>
          </div>
          <div><p className="font-semibold mb-1">Équipe et matériel</p>
            <ul className="list-disc ml-5">{c.ressources.map((r) => <li key={r.id}>{r.nom}{r.role && ` – ${r.role}`}</li>)}</ul></div>
          {c.taches_prep?.length > 0 && <div><p className="font-semibold mb-1">Préparation</p>
            {c.taches_prep.map((t, i) => (
              <label key={i} className="flex items-center gap-2 py-0.5"><Checkbox data-testid={`prep-${i}`} checked={!!t.fait} onCheckedChange={() => cocher(i)} />{t.titre}{t.responsable && <span className="text-stone-500">({t.responsable})</span>}</label>
            ))}</div>}
          {c.a_trouver?.length > 0 && <div><p className="font-semibold mb-1">À trouver : {c.a_trouver.join(', ')}</p>
            {c.annonce_recrutement && <p data-testid="chantier-annonce" className="whitespace-pre-line bg-stone-50 rounded-lg p-2 text-stone-700">{c.annonce_recrutement}</p>}
            {c.annonce_recrutement && !c.annonce_validee && <Button data-testid="annonce-valider-btn" size="sm" variant="outline" className="mt-2 rounded-full" onClick={() => maj({ annonce_validee: true })}>Valider l'annonce</Button>}
            {c.annonce_validee && <p className="text-emerald-700 text-xs mt-1">Annonce validée</p>}</div>}
          <div><p className="font-semibold mb-1">Heures ({totalH} h)</p>
            {(c.heures || []).map((x, i) => <p key={i} className="text-stone-600">{x.date} · {x.personne} · {x.heures} h</p>)}
            <div className="flex gap-2 mt-1">
              <Input data-testid="heures-personne" placeholder="Personne" value={h.personne} onChange={(e) => setH({ ...h, personne: e.target.value })} />
              <Input data-testid="heures-date" type="date" value={h.date} onChange={(e) => setH({ ...h, date: e.target.value })} />
              <Input data-testid="heures-nb" type="number" placeholder="h" className="w-20" value={h.heures} onChange={(e) => setH({ ...h, heures: e.target.value })} />
              <Button data-testid="heures-ajouter-btn" size="sm" disabled={!h.personne || !h.heures || !h.date} onClick={ajouterHeures}>Ajouter</Button>
            </div></div>
          {c.statut !== 'termine' ? (
            <div className="flex items-end gap-2 border-t pt-3">
              <div><label className="text-xs text-stone-500">Prix horaire HT (facture)</label><Input data-testid="chantier-prix-heure" type="number" value={prix} onChange={(e) => setPrix(e.target.value)} /></div>
              <Button data-testid="chantier-terminer-btn" variant="outline" className="rounded-full" disabled={enCours} onClick={terminer}>Terminer et préparer la facture</Button>
            </div>
          ) : <p data-testid="chantier-termine" className="text-emerald-700 border-t pt-3">Terminé · traçabilité parcellaire enregistrée · facture en brouillon pour Pierre Moreau</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
